import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';

import { environment } from '@env/environment';
import { FeatureFlag } from '@env/environment.interface';

@Directive({
  selector: '[sparkFeatureFlag]'
})
export class FeatureFlagDirective implements OnInit {
  private featureFlag!: FeatureFlag;
  constructor(private tpl: TemplateRef<any>, private vcr: ViewContainerRef) {}

  @Input()
  set sparkFeatureFlag(featureFlag: FeatureFlag) {
    this.featureFlag = featureFlag;
    this.displayTemplate();
  }

  @Input() sparkFeatureFlagElse?: TemplateRef<unknown>;

  ngOnInit() {
    this.displayTemplate();
  }

  private displayTemplate() {
    this.vcr.clear();
    const isEnabled = !!environment.features[this.featureFlag];
    if (isEnabled) {
      this.vcr.createEmbeddedView(this.tpl);
    } else if (this.sparkFeatureFlagElse) {
      this.vcr.createEmbeddedView(this.sparkFeatureFlagElse);
    }
  }
}
